import { HighPriorityNovaModalContainer } from "@nova/component-nova-modal-container"
import { useAppDispatch } from "integrations/redux/hooks"
import { hideGlobalModal, showGlobalModal } from "runlevel/actions"
import { ModalNames } from "./types"
import { initializeCenterModalForComponentAction } from "features/content-overlay/slice"
import { ButtonSecondary } from "@nova/component-btn"
import { getBrowserDetector } from "@nova/util-browser"
import store from "integrations/redux/store"

const ScreenSizeAlertModal = () => {
    const dispatch = useAppDispatch()
    const browserDetector = getBrowserDetector()
    const isChrome = browserDetector.isChrome()

    return (
        <HighPriorityNovaModalContainer
            title={isChrome ? "Best on Desktop" : "Best on Desktop & Chrome"}
            bottomBar={
                <div className="flex w-full justify-end">
                    <ButtonSecondary onClick={() => dispatch(hideGlobalModal())} title="Continue" />
                </div>
            }
            closeModal={() => dispatch(hideGlobalModal())}
            className="max-w-[400px] w-full"
        >
            <h4 className="text-center">
                {isChrome
                    ? "We recommend using Nova on a laptop or desktop computer for the best experience mapping."
                    : "We recommend using Nova on a laptop or desktop computer using Google Chrome for the best experience mapping."}
            </h4>
        </HighPriorityNovaModalContainer>
    )
}

let hasDisplayed = false
const screenSizeAlertModal = () => {
    const isMobile = window.screen.width < 900

    if (isMobile && !hasDisplayed) {
        store.dispatch(initializeCenterModalForComponentAction(ModalNames.ScreenSizeAlertModal))
        store.dispatch(showGlobalModal())
        hasDisplayed = true
    }
}

export { ScreenSizeAlertModal, screenSizeAlertModal }
